import React, { useEffect, useState } from "react";
import styled from "styled-components";
import LoginCard from "../../Components/AuthenticationComponents/LoginCard";
import { lightThemeColors } from "../../assets/styles/colors";

import LoaderComponent from "../../Components/Generic/LoaderComponent";
import { useNavigate } from "react-router-dom";
import LocalStorage from "../../helper/LocalStorage";
import { authBridgeLogin } from "../../api/authBridge";
import { useUserContext } from "../../context/useUserContext";

const LoginPage = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { fetchCurrentUser } = useUserContext();

    const navigateToWebpage = () => {
        window.location.replace("http://emotii.ai")
    }

    useEffect(() => {
      const params = new URLSearchParams(window.location.search);
      const bridgeToken = params.get("bridge");

      if (bridgeToken) {
        LocalStorage.removeBridgeOptedOut();
        window.history.replaceState(null, "", "/login");
        setLoading(true);
        authBridgeLogin(bridgeToken).then((result) => {
          const attempt = result?.token
            ? Promise.resolve(result)
            : authBridgeLogin();
          attempt.then((finalResult) => {
            if (finalResult?.token && finalResult?.refresh_token) {
              LocalStorage.setAuthenthicationToken(finalResult.token);
              LocalStorage.setRefreshToken(finalResult.refresh_token);
              LocalStorage.setSSOFlag(true);
              fetchCurrentUser(
                () => { setLoading(false); navigate("/dashboard"); },
                () => { setLoading(false); }
              );
            } else {
              setLoading(false);
            }
          });
        });
        return;
      }

      const existingToken = LocalStorage.getAuthenticationToken();
      if (existingToken) return;
      if (LocalStorage.getBridgeOptedOut()) return;
      setLoading(true);

      authBridgeLogin().then((result) => {
          if (result?.token && result?.refresh_token) {
              LocalStorage.setAuthenthicationToken(result.token);
              LocalStorage.setRefreshToken(result.refresh_token);
              LocalStorage.setSSOFlag(true);

              fetchCurrentUser(
                  () => {
                      setLoading(false);
                      navigate("/dashboard");
                  },
                  () => {
                      setLoading(false);
                  }
              );
          } else {
              setLoading(false);
          }
      });
    }, []);

    return (
        <LoaderComponent loading={loading}>
            <Container>
                <LeftPanel>
                    <LoginCard setIsLoading={setLoading} />
                    <Footer>
                        © copyright 2025 emotii ai.
                    </Footer>
                </LeftPanel>
                <RightPanel>
                    <BrandingContent>
                        <LogoWrapper>
                            <img src="/emotii.avif" alt="Emotii Logo" />
                        </LogoWrapper>
                        <TaglineText>
                            Enable emotii for your whole team and integrate <HighlightText>powerful, modern communication tools</HighlightText> into your workflows in minutes.
                        </TaglineText>
                    </BrandingContent>
                </RightPanel>
            </Container>
        </LoaderComponent>
    );
};

export default LoginPage;

const Container = styled.div`
  display: flex;
  height: 100vh;
  width: 100%;
  overflow: hidden;

  @media(max-width: 1024px) {
    flex-direction: column;
  }
`;

const LeftPanel = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${lightThemeColors.background};
  padding: 40px;
  min-height: 100vh;
  box-sizing: border-box;

  @media(max-width: 650px) {
    padding: 20px;
  }
`;

const RightPanel = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(248, 248, 248, 1) 0%, rgba(240, 240, 245, 1) 100%);
  padding: 60px;

  @media(max-width: 1024px) {
    display: none;
  }
`;

const BrandingContent = styled.div`
  max-width: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
`;

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 280px;
  width: 100%;

  img {
    width: 100%;
    height: auto;
  }
`;

const TaglineText = styled.p`
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  text-align: center;
  margin: 0;
`;

const HighlightText = styled.span`
  color: ${lightThemeColors.primaryColor};
  font-weight: 600;
`;

const Footer = styled.div`
  margin-top: 40px;
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  text-align: center;
`;

